import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SEOHead from "@/components/feature/SEOHead";
import { faqData } from "@/mocks/articles";

export default function About() {
  const location = useLocation();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormSubmitted(true);
      return;
    }

    try {
      const formData = new FormData(form);
      const response = await fetch("https://readdy.ai/api/form/d9oqnk0senbniolesk7g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === "OK") {
        setFormSubmitted(true);
        setFormError("");
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "提交失败，请重试";
        setFormError(msg);
      }
    } catch {
      setFormError("网络错误，请检查网络连接后重试");
    }
  };

  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于51吃瓜官网",
    description: "51吃瓜官网是领先的娱乐八卦资讯平台，提供最新明星黑料、网红翻车、社会热点等爆料内容",
    url: "https://51chigua.com/about",
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 51吃瓜官网 | 品牌介绍与联系方式"
        description="51吃瓜官网是领先的娱乐八卦资讯平台。了解我们的品牌故事、信誉背书、团队介绍以及联系方式。吃瓜爆料第一站，值得信赖！"
        keywords="51吃瓜官网,关于51吃瓜,51吃瓜联系方式,51吃瓜品牌介绍"
        canonicalUrl="https://51chigua.com/about"
        schemaData={[aboutSchema, faqSchema]}
      />

      <Navbar />

      <main className="pt-20">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-6">
          <Breadcrumb
            items={[
              { label: "首页", href: "/" },
              { label: "关于我们" },
            ]}
          />
        </div>

        {/* Hero */}
        <section className="relative w-full py-16 md:py-24 bg-background-100 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-primary-50/50 via-background-100 to-accent-50/30"></div>
          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
              关于 51吃瓜官网
            </h1>
            <p className="text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              全网最火爆的娱乐八卦爆料平台，吃瓜群众的第一选择
            </p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
              <h2 className="font-heading text-2xl font-bold text-foreground-900">品牌介绍</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  <strong>51吃瓜官网</strong>成立于2020年，是国内领先的娱乐八卦资讯聚合平台。"51"谐音"我要"，"吃瓜"是网络流行语，意味着围观、看热闹。我们致力于为每一位<strong>吃瓜群众</strong>提供最新鲜、最真实、最劲爆的娱乐资讯和<strong>黑料爆料</strong>。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  我们的编辑团队由资深娱乐记者和自媒体人组成，拥有丰富的行业资源和敏锐的新闻嗅觉。每天24小时不间断追踪娱乐圈动态，第一时间为读者呈现最热门的<strong>明星八卦</strong>和<strong>社会热点</strong>。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  截至2026年，51吃瓜官网已累计发布超过5000篇爆料文章，月活跃用户突破500万，成为中文互联网最具影响力的吃瓜平台之一。
                </p>
              </div>
              <div className="rounded-xl overflow-hidden h-64 md:h-full">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20Chinese%20media%20office%20workspace%20with%20entertainment%20news%20screens%20on%20walls%20warm%20lighting%20professional%20atmosphere%20editorial%20newsroom%20design%20team%20collaboration%20creative%20workspace%20stylish%20interior&width=600&height=400&seq=about-brand-01&orientation=landscape"
                  alt="51吃瓜官网团队"
                  title="51吃瓜官网编辑团队"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-12 bg-primary-500">
          <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              {[
                { value: "5000+", label: "爆料文章" },
                { value: "500万+", label: "月活用户" },
                { value: "30+", label: "编辑团队" },
                { value: "99.9%", label: "内容真实率" },
              ].map((stat) => (
                <div key={stat.label} className="py-4">
                  <p className="text-3xl md:text-4xl font-bold text-white mb-1">{stat.value}</p>
                  <p className="text-sm text-white/70">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
              <h2 className="font-heading text-2xl font-bold text-foreground-900">信誉背书</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  icon: "ri-shield-check-line",
                  title: "严格审核机制",
                  desc: "每一条爆料内容都经过编辑团队的多方核实和交叉验证，确保信息的真实性和准确性。拒绝传播虚假信息和未经证实的谣言。",
                },
                {
                  icon: "ri-lock-line",
                  title: "隐私保护承诺",
                  desc: "我们严格遵守个人信息保护法律法规，对所有爆料人的身份信息实行最高级别的保密措施，确保爆料人的隐私安全。",
                },
                {
                  icon: "ri-scales-line",
                  title: "合规合法运营",
                  desc: "51吃瓜官网已取得互联网新闻信息服务许可，所有内容发布均符合国家法律法规要求。我们积极配合监管部门，维护良好的网络环境。",
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="p-6 rounded-xl bg-background-100 border border-background-200/70"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
              <h2 className="font-heading text-2xl font-bold text-foreground-900">常见问题</h2>
            </div>
            <div className="flex flex-col gap-3">
              {faqData.map((faq, index) => (
                <details key={index} className="group bg-background-50 rounded-xl border border-background-200/70">
                  <summary className="flex items-center justify-between p-5 cursor-pointer font-medium text-foreground-900 list-none">
                    <span>{faq.question}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg"></i>
                  </summary>
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
              <h2 className="font-heading text-2xl font-bold text-foreground-900">联系我们</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <div>
                <div className="flex flex-col gap-5">
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-medium text-foreground-900 mb-1">电子邮箱</h3>
                      <p className="text-sm text-foreground-600">contact@51chigua.com</p>
                      <p className="text-sm text-foreground-500 mt-0.5">商务合作 / 投稿爆料</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-wechat-line text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-medium text-foreground-900 mb-1">微信公众号</h3>
                      <p className="text-sm text-foreground-600">51吃瓜爆料第一站</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-weibo-line text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-medium text-foreground-900 mb-1">新浪微博</h3>
                      <p className="text-sm text-foreground-600">@51吃瓜官网</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">意见反馈</h3>
                {formSubmitted ? (
                  <div className="text-center py-8">
                    <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                      <i className="ri-check-line text-2xl text-primary-600"></i>
                    </div>
                    <p className="text-foreground-900 font-medium mb-1">感谢您的反馈！</p>
                    <p className="text-sm text-foreground-500">我们会尽快处理您的意见</p>
                  </div>
                ) : (
                  <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    {formError && (
                      <div className="p-3 rounded-lg bg-primary-50 text-primary-700 text-sm">
                        {formError}
                      </div>
                    )}
                    <div>
                      <input
                        type="text"
                        name="name"
                        placeholder="您的称呼"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                      />
                    </div>
                    <div>
                      <input
                        type="email"
                        name="email"
                        placeholder="电子邮箱"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                      />
                    </div>
                    <div>
                      <textarea
                        name="message"
                        placeholder="请输入您的意见或建议..."
                        rows={4}
                        maxLength={500}
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                      ></textarea>
                      <p className="text-xs text-foreground-400 mt-1">最多500字符</p>
                    </div>
                    <div className="form-honeypot">
                      <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                    </div>
                    <button
                      type="submit"
                      className="w-full py-2.5 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      提交反馈
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}